import { compareDailyJobsSceneSets, type DailyCompare } from '@apis/simulation';
import { useAbortableFetch } from './useAbortableFetch';

/** 汇总树和明细筛选共用一次请求；切换任务或 check 口径时清掉旧树。 */
export function useSceneSetComparison(todayJobId: number, compareJobId: number | null, revision: DailyCompare | null) {
  const fetcher = compareJobId && revision?.today.jobId === todayJobId && revision.compare.jobId === compareJobId
    ? (signal: AbortSignal) => compareDailyJobsSceneSets(todayJobId, compareJobId, signal)
    : null;
  return useAbortableFetch(fetcher, [todayJobId, compareJobId, revision], '加载场景集对比失败');
}

interface SceneSetOption {
  value: number;
  title: string;
  label: string;
  children?: SceneSetOption[];
}

interface SceneSetTreeNode { nodeId: number; name: string; children: SceneSetTreeNode[] }

export function sceneSetOptions(nodes: SceneSetTreeNode[], parents: string[] = []): SceneSetOption[] {
  return nodes.map((node) => {
    const path = [...parents, node.name];
    return {
      value: node.nodeId,
      title: node.name,
      label: path.join(' / '),
      children: node.children.length ? sceneSetOptions(node.children, path) : undefined,
    };
  });
}
